import { mapActions, mapGetters, mapMutations } from 'vuex';
import { formatPrice } from 'utils/general';

export default {
  components: {
    'vue-image': () => import('../vue-image/vue-image.vue'),
  },
  props: ['product'],
  computed: {
    ...mapGetters('global', ['rewardUserList']),
    productSelected() {
      return this.rewardUserList.includes(this.product.id);
    },
    removeText() {
      return this.$t('cart.gwp.remove');
    },
    freeText() {
      return this.$t('cart.gwp.free');
    },
    chooseElementText() {
      return this.$t('cart.gwp.choose_gwp_element');
    },
    ctaText() {
      return this.productSelected ? this.removeText : this.chooseElementText;
    },
  },
  methods: {
    ...mapActions('global', ['openModal']),
    ...mapActions('quickView', [
      'setProduct',
      'updateModalTitle',
      'updateCtaText',
    ]),
    ...mapMutations('quickView', ['setGWPLayout']),
    formattedTitle(string) {
      return string.split(window.__GLOBAL__.productDelimiter)[0];
    },
    variantTitle(string) {
      return string.split(window.__GLOBAL__.productDelimiter)[1];
    },
    formattedPrice(price) {
      return formatPrice(price);
    },
    addProductToList(product) {
      this.updateModalTitle(this.$t('quick_view.quick_view_title'));
      this.updateCtaText(this.$t('quick_view.add_to_bag'));
      this.setProduct(product);
      this.setGWPLayout(true);
      this.openModal('quick-view');
    },
  },
  template: `
    <div
      class="product-card"
      :class="{ 'active': productSelected }"
    >
      <div class="relative">
        <div class="product-card__featured">
          <div class="img fit-cover product-card__image fit-cover is-loaded pos-center">
            <img :src="product.featuredImage" :alt="product.title" :title="product.title" class="img__el">
          </div>
        </div>
        <div class="product-card__details">
          <p class="product-card__details-title p1 bold uppercase" v-text="formattedTitle(product.title)"></p>
          <p class="product-card__details__variant p1" v-text="variantTitle(product.title)"></p>
          <div class="product-card__details__pricing-info OneLinkNoTx f">
            <p v-if="product.price > 0" :aria-label="'Price: '+ formattedPrice(product.price)" class="p1 bold product-card__details__price" v-text="formattedPrice(product.price)"></p>
            <p v-else class="p1 bold product-card__details__price uppercase" v-text="freeText"></p>
          </div>
        </div>
        <button
          @click.prevent="addProductToList(product)"
          class="product-card__cta product-card__cta--shop-now"
          :class="[ productSelected ? 'a1 underline' : 'btn btn--outlined' ]"
          data-module-name="gwp item"
          v-text="ctaText"
        ></button>
      </div>
    </div>`,
};
